"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullNameFieldLogic = void 0;
var full_name_fieldtype_1 = require("./full-name.fieldtype");
Object.defineProperty(exports, "FullNameFieldLogic", { enumerable: true, get: function () { return full_name_fieldtype_1.FullNameFieldLogic; } });
